// extracted by mini-css-extract-plugin
export var numpadContainer = "_p2-1";
export var phoneButton = "_p2-0";